import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-que-es-cuantrix',
  templateUrl: './que-es-cuantrix.component.html',
  styleUrls: ['./que-es-cuantrix.component.scss']
})
export class QueEsCuantrixComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
